import React from 'react';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

function UsersTableSkeleton() {
    return (
        <Stack spacing={1} padding={0} paddingTop={2} mt={4}>
            <Skeleton variant="rounded" width={'100%'} height={35} />
            <Skeleton variant="rounded" width={'100%'} height={35} />
            <Skeleton variant="rounded" width={'100%'} height={35} />
            <Skeleton variant="rounded" width={'100%'} height={35} />
            <Skeleton variant="rounded" width={'100%'} height={35} />
            <Skeleton variant="rounded" width={'100%'} height={35} />
            <Skeleton variant="rounded" width={'100%'} height={35} />
            <Skeleton variant="rounded" width={'100%'} height={35} />
            <Skeleton variant="rounded" width={'100%'} height={35} />
        </Stack>
    );
}

export default UsersTableSkeleton;
